
import Base from "@/components/Text/Base.vue";

export default class Right extends Base {
  id = "full_right";
  defaultText = "Right text";
}
